"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var Dropdown_module_scss_1 = __importDefault(require("./Dropdown.module.scss"));
/**
 * @deprecated DropdownMenu is deprecated. Please use draft-menu instead.
 */
var DropdownMenu = /** @class */ (function (_super) {
    __extends(DropdownMenu, _super);
    function DropdownMenu() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.menu = react_1["default"].createRef();
        _this.handleDocumentClick = function (e) {
            if (_this.menu &&
                _this.menu.current &&
                e.target instanceof Node &&
                !_this.menu.current.contains(e.target)) {
                _this.props.hideDropdownMenu();
            }
        };
        _this.handleDocumentResize = function () {
            _this.props.hideDropdownMenu();
        };
        return _this;
    }
    DropdownMenu.prototype.componentDidMount = function () {
        document.addEventListener("click", this.handleDocumentClick, false);
        window.addEventListener("resize", this.handleDocumentResize, false);
        this.positionMenu();
    };
    DropdownMenu.prototype.componentWillUnmount = function () {
        document.removeEventListener("click", this.handleDocumentClick, false);
        window.removeEventListener("resize", this.handleDocumentResize, false);
    };
    DropdownMenu.prototype.render = function () {
        var _a = this.props, hideDropdownMenu = _a.hideDropdownMenu, children = _a.children;
        return (
        // Disabling instead of addressing because this component is deprecated
        // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
        react_1["default"].createElement("div", { className: Dropdown_module_scss_1["default"].menuContainer, ref: this.menu, onClick: hideDropdownMenu }, children));
    };
    DropdownMenu.prototype.positionMenu = function () {
        var menu = this.menu;
        if (!this.props.position || !menu) {
            return;
        }
        if (menu.current) {
            var pos = this.props.position;
            var innerHeight_1 = window.innerHeight;
            var rect = menu.current.getBoundingClientRect();
            if (pos.bottom > innerHeight_1 - rect.height) {
                menu.current.style.bottom = "24px";
                menu.current.style.top = "auto";
            }
            else {
                menu.current.style.top = "24px";
                menu.current.style.bottom = "auto";
            }
        }
    };
    DropdownMenu.displayName = "DropdownMenu";
    return DropdownMenu;
}(react_1["default"].Component));
exports["default"] = DropdownMenu;
//# sourceMappingURL=DropdownMenu.js.map